module.exports = __webpack_public_path__ + "img/ccf-vi-VN.6d25e150.png";